export const adminEventTickets = (params: { eventId: number }) => `event:${params.eventId}`;
